import { Injectable } from '@angular/core';
import { from, type Observable } from 'rxjs';
import type {
  AdminPointOfInterestGetDto,
  AdminPointOfInterestListDto,
  AdminPointOfInterestPostPutDto,
} from '../../../../backend/main';
import {
  listAdminPointsOfInterestAsync,
  createPointOfInterestAsync,
  findPointOfInterestAsync,
  updatePointOfInterestAsync,
  deletePointOfInterestAsync,
} from '../../../../backend/main';
import type { DtoListService, GetAllRequestParameters, ListPaginatedDTO } from '@pct/ng-core-dto';
import { UNKNOWN_ITEM } from '@pct/ng-core-dto';
import { isNil } from '@pct/ts-typeguard';
import type { FilteredParams } from '../../../common/request/filtered-params';
import type { PoiFilter } from './poi-filter';
import { convertPaginationParams } from '../../../common/utils/table/convert-pagination-params';
import { mapSort } from '../../../common/request/map-sort';

export type PoiListDto = AdminPointOfInterestListDto;

@Injectable()
export class PoisDtoService implements DtoListService<
  PoiListDto,
  FilteredParams<PoiListDto, PoiFilter>
> {
  getAll(
    param: GetAllRequestParameters<FilteredParams<PoiListDto, PoiFilter>>,
  ): Observable<ListPaginatedDTO<PoiListDto>> {
    return from(
      listAdminPointsOfInterestAsync({
        body: {
          pagination: convertPaginationParams(param.pagination),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          sort: mapSort(param.parameters?.sort) as any,
          searchText: param.parameters?.filter?.searchText,
        },
      }).then(resp => resp.data),
    );
  }

  delete(id: string): Observable<void> {
    return from(deletePointOfInterestAsync({ path: { id } }).then(resp => resp.data));
  }

  getDtoId(dto: PoiListDto): string;
  getDtoId(dto: PoiListDto | null | undefined): string | null | undefined;
  getDtoId(dto: Partial<PoiListDto> | null | undefined): string | null | undefined;
  getDtoId(dto: PoiListDto | Partial<PoiListDto> | null | undefined): string | null | undefined {
    if (isNil(dto)) {
      return dto;
    }
    return dto.id;
  }

  toString(dto: PoiListDto): string {
    return dto.address ?? UNKNOWN_ITEM;
  }

  getById(id: string): Observable<AdminPointOfInterestGetDto> {
    return from(findPointOfInterestAsync({ path: { id } }).then(resp => resp.data));
  }

  create(data: AdminPointOfInterestPostPutDto): Observable<void> {
    return from(
      createPointOfInterestAsync({ body: data }).then(() => {
        //VOID
      }),
    );
  }

  update(id: string, data: AdminPointOfInterestPostPutDto): Observable<void> {
    return from(updatePointOfInterestAsync({ path: { id }, body: data }).then(resp => resp.data));
  }
}
